//
// Copyright 2020 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/field_options.proto (syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file dxos/field_options.proto.
 */
export const file_dxos_field_options: GenFile = /*@__PURE__*/
  fileDesc("ChhkeG9zL2ZpZWxkX29wdGlvbnMucHJvdG86RAoMcHJlc2VydmVfYW55Eh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxjAPiABKAhSC3ByZXNlcnZlQW55iAEBYgZwcm90bzM", [file_google_protobuf_descriptor]);

/**
 * @generated from extension: optional bool preserve_any = 8000;
 */
export const preserve_any: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_dxos_field_options, 0);

